<div class="container">
  <h1>Hafa samband og tímabókanir</h1>
  <div class="texti">
    Til að hafa samband eða bóka tíma er best að senda okkur skilaboð á Facebook. Einnig er hægt að hringja í síma: 895-0219 eða senda tölvupóst á sveinngauti@sveinngauti.is
  </div>
</div>
